import React, { useState, useEffect, useRef } from "react";
import { logo } from "../component/ImageList";
import { useNavigate } from "react-router-dom";
import { initLoginAnimation } from "../utils/loginAnimation";
import baseURL from "../component/baseURL";
import showNotification from "../component/Notification";
import "animate.css";
import { ReactNotifications } from "react-notifications-component";
import { SignInCard } from "../components/ui/sign-in-card-2";

export default function Login() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const canvasContainerRef = useRef(null);
    const animationRef = useRef(null);
    const sceneRef = useRef(null);

    useEffect(() => {
        const cleanup = initLoginAnimation(canvasContainerRef, animationRef, sceneRef);
        return cleanup;
    }, []);

    useEffect(() => {
        document.body.classList.add("login-page");
        return () => {
            document.body.classList.remove("login-page");
        };
    }, []);

    useEffect(() => {
        const userId = localStorage.getItem("user_id");
        if (userId) {
            navigate("/home", { replace: true });
        }
    }, [navigate]);

    function loginApi() {
        if (isLoading) return;
        setIsLoading(true);

        const formdata = new FormData();
        formdata.append("username", email);
        formdata.append("password", password);

        fetch(baseURL.URL + "/users/login", {
            method: "POST",
            body: formdata,
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server.result_code === 200) {
                    localStorage.setItem("user_id", responseJson.response.user_id);
                    localStorage.setItem("user_fname", responseJson.response.fname);
                    localStorage.setItem("user_lname", responseJson.response.lname);
                    localStorage.setItem("user_email", responseJson.response.user_email);
                    localStorage.setItem("user_picture", responseJson.response.picture);
                    showNotification(responseJson.server.message, "success");
                    navigate("/home");
                } else {
                    showNotification("Error", responseJson.server.message, "danger");
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification("Error", "Login failed. Please try again.", "danger");
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <>
            <ReactNotifications />
            <section className="login-section relative min-h-screen">
                <div id="canvas_container" ref={canvasContainerRef} />

                <div className="login-sign-in-overlay">
                <SignInCard
                    embedded
                    email={email}
                    onEmailChange={setEmail}
                    password={password}
                    onPasswordChange={setPassword}
                    showPassword={showPassword}
                    onTogglePassword={() => setShowPassword((prev) => !prev)}
                    onSubmit={loginApi}
                    isLoading={isLoading}
                    logoSrc={logo}
                    title="Welcome Back!"
                    description="Please log in to your account to continue."
                />
                </div>
            </section>
        </>
    );
}
